import { defineMessages } from 'react-intl'

export default defineMessages({
  select: {
    id: 'components.Voice.select',
    defaultMessage: 'Select',
  },
  deselect: {
    id: 'components.Voice.deselect',
    defaultMessage: 'Deselect',
  },
  selectDemo: {
    id: 'components.Voice.selectDemo',
    defaultMessage: 'Select',
  },
  deselectDemo: {
    id: 'components.Voice.deselectDemo',
    defaultMessage: 'Deselect',
  },
  latestJob: {
    id: 'components.Voice.latestJob',
    defaultMessage: 'Used {time}',
  },
  available: {
    id: 'components.Voice.available',
    defaultMessage: 'Available',
  },
  addNote: {
    id: 'components.Voice.addNote',
    defaultMessage: 'Add note',
  },
  expandDemos: {
    id: 'components.Voice.expandDemos',
    defaultMessage:
      'Show {count, plural, one {one more demo} other {# more demos}}',
  },
  collapseDemos: {
    id: 'components.Voice.collapseDemos',
    defaultMessage: 'Show less demos',
  },
  activeWarning: {
    id: 'components.Voice.activeSupplierWarning',
    defaultMessage: 'Active',
  },
  showMoreDemos: {
    id: 'components.Voice.showMoreDemos',
    defaultMessage:
      '{count, plural, =0 {More info} one {one more demo} other {# more demos}}',
  },
  tooltip:{
    id:'components.Voice.tooltip',
    defaultMessage: "Voices with fixed rates, ensuring you cost efficient productions with fast turnaround."
  },
  voicetalentUnavailable:{
    id:'components.Voice.voicetalentUnavailable',
    defaultMessage: "Unavailable to record through the following dates:"
  },
  OptionallyAddNote:{
    id:'components.Voice.OptionallyAddNote',
    defaultMessage: 'Optionally add note..'
  },
  noDemos:{
    id:'components.Voice.noDemos',
    defaultMessage:`No demos for the selected filter. Click play to listen to alternative demo from {sku}`
  },
  moreDetails:{
    id:'components.Voice.moreDetails',
    defaultMessage: "Click to see more details."
  },
  commercialBaseRate:{
    id:'components.Voice.commercialBaseRate',
    defaultMessage: "Commercial base rate"
  },
  videoBaseRate:{
    id:'components.Voice.videoBaseRate',
    defaultMessage: "Video Presentation base rate"
  },
  unavailableWithDate: {
    id:'components.Voice.unavailableWithDate',
    defaultMessage:'Unavailable until {date}'
  },
  unavailableFallback:{
    id:'components.Voice.unavailableFallback',
    defaultMessage:'<span>Unavailability coming up</span>'
  }
})
